var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getVirtualizedAppName } from "../../View/Hooks/useVirtualizedApp";
import ParamsService from "../../Services/Shared/Params.service";
export default class PersonDomainService {
    static makeLinkToPerson({ affiliationId, tabId, virtualizedApp, personType, queryParams, }) {
        return (`/aviso/${virtualizedApp !== null && virtualizedApp !== void 0 ? virtualizedApp : "find"}/app/advisor/people/${personType !== null && personType !== void 0 ? personType : "find"}?` +
            ParamsService.toQueryString(Object.assign(Object.assign({}, (queryParams !== null && queryParams !== void 0 ? queryParams : {})), { studentId: affiliationId, tabId })));
    }
    /**
     * TODO need to integrate this with caching somehow
     *
     * @deprecated
     */
    static getLinkToPerson(affiliationId, tabId, virtualizedApp, personType) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!virtualizedApp) {
                virtualizedApp = getVirtualizedAppName();
            }
            if (!virtualizedApp) {
                virtualizedApp = "find";
            }
            if (!personType) {
                personType = "find";
            }
            return PersonDomainService.makeLinkToPerson({
                virtualizedApp,
                personType,
                affiliationId,
                tabId,
            });
        });
    }
}
